import alt from '../alt'
import MessageActions from '../actions/MessageActions'

class MessageStore {
  constructor () {
    this.bindActions(MessageActions)
    this.messages = []
  }

  onFetchedMessages (messages) {
    this.messages = messages
  }

}

module.exports = alt.createStore(MessageStore, 'MessageStore')



// WEBPACK FOOTER //
// ./src/stores/MessageStore.js